import React from 'react';
import { motion } from 'framer-motion';
import { SlideWrapper } from '../ui/SlideWrapper';
import { Factory, Hammer, UtensilsCrossed, Wrench, Landmark, Zap, HeartPulse, Sparkles } from 'lucide-react';
const industries = [{
  icon: Factory,
  name: 'Industrie & Produktion'
}, {
  icon: Hammer,
  name: 'Handwerk & Gewerbe'
}, {
  icon: UtensilsCrossed,
  name: 'Gastronomie & Food'
}, {
  icon: Wrench,
  name: 'Maschinen- & Anlagenbau'
}, {
  icon: Landmark,
  name: 'Finanzen & Versicherung'
}, {
  icon: Zap,
  name: 'Energie & Versorgung'
}, {
  icon: HeartPulse,
  name: 'Gesundheit & Pflege'
}, {
  icon: Sparkles,
  name: 'Und viele mehr …'
}];
export function IndustriesSlide() {
  return <SlideWrapper data-id="element-147">
      <div className="h-full flex flex-col justify-center" data-id="element-148">
        <motion.div className="text-center mb-10" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} data-id="element-149">
          <h2 className="text-5xl font-bold text-primary mb-3" data-id="element-150">
            Branchen & Einsatzfelder
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto" data-id="element-151">
            Überall dort, wo Prozesse digitaler und effizienter werden sollen —
            branchenunabhängig.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto w-full" data-id="element-152">
          {industries.map((item, index) => {
          const isLast = index === industries.length - 1;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.15 + index * 0.08
          }} className={`group relative overflow-hidden rounded-2xl p-6 flex flex-col items-center justify-center text-center transition-colors duration-500 cursor-default ${isLast ? 'bg-primary text-white' : 'bg-bg-alt hover:bg-primary'}`} data-id="element-153">
                <div className={`w-14 h-14 rounded-full flex items-center justify-center mb-4 shadow-sm transition-transform duration-500 group-hover:scale-110 ${isLast ? 'bg-accent/20' : 'bg-white'}`} data-id="element-154">
                  <item.icon className={`w-7 h-7 transition-colors duration-300 ${isLast ? 'text-accent' : 'text-primary'}`} data-id="element-155" />
                </div>
                <h3 className={`text-base font-bold transition-colors duration-300 ${isLast ? 'text-white' : 'text-primary group-hover:text-white'}`} data-id="element-156">
                  {item.name}
                </h3>

                <div className="absolute -bottom-8 -right-8 w-24 h-24 bg-accent/20 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-157" />
              </motion.div>;
        })}
        </div>
      </div>
    </SlideWrapper>;
}